export default __webpack_public_path__ + "static/media/3.403c340b.jpg";